module.exports = __webpack_public_path__ + "img/activity-feed-preview.47149c08.png";